import React from 'react';
import { Box, makeStyles, IconButton } from '@material-ui/core';
import { Renew } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';

interface MyAccountSwitchHeaderProps {
  onSwitch: () => void;
}

const MyAccountSwitchHeader: React.FC<MyAccountSwitchHeaderProps> = ({
  onSwitch
}) => {
  const { switchAccount } = useMyAccountSwitchStyles();

  return (
    <Box className={switchAccount} onClick={onSwitch}>
      <CustomizedTypography variant="body1">파트너로 전환</CustomizedTypography>
      <IconButton size="medium">
        <Renew size={24} color={colorSet.gray000} />
      </IconButton>
    </Box>
  );
};

export default MyAccountSwitchHeader;

const useMyAccountSwitchStyles = makeStyles((theme) => ({
  switchAccount: {
    position: 'sticky',
    display: 'flex',
    top: 68,
    width: '100%',
    paddingLeft: '16px',
    paddingRight: '4px',
    height: '56px',
    padding: '0px 16px',
    backgroundColor: colorSet.gray900,
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 2,
    '& > p': {
      color: colorSet.gray000
    },
    '& > button': {
      padding: 6
    }
  }
}));
